<template>
  <div class="animated fadeIn">
    <h1 class="my-header">Accueil</h1>
  </div>
</template>

<script>
    export default {
        name: "Accueil"
    }
</script>

<style scoped>
.my-header {
  color: #FFFFFF !important;
}
</style>
